import { useScrollReveal } from '@/hooks/useScrollReveal';

export default function AboutSection() {
  const stats = [
    { value: '120+', label: 'Projects Delivered' },
    { value: '8+', label: 'Years of Experience' },
    { value: '40+', label: 'Experts on Team' },
    { value: '95%', label: 'Client Retention' },
  ];

  const { ref: leftRef, isVisible: leftVisible } = useScrollReveal();
  const { ref: rightRef, isVisible: rightVisible } = useScrollReveal();

  return (
    <section id="about-us" className="bg-nv-light py-20 md:py-28 lg:py-32">
      <div className="w-full px-6 md:px-10 lg:px-16">
        <div className="max-w-7xl mx-auto">
          <div className="flex flex-col lg:flex-row gap-12 lg:gap-20 items-start">
            <div
              ref={leftRef}
              className={`lg:w-[48%] transition-all duration-700 ${
                leftVisible ? 'opacity-100 translate-x-0' : 'opacity-0 -translate-x-10'
              }`}
            >
              <span className="text-nv-muted text-sm tracking-widest uppercase mb-4 block">
                ( About the Company )
              </span>
              <h2 className="font-serif text-nv-black text-3xl md:text-4xl lg:text-5xl font-medium leading-tight">
                We Build Digital Solutions
                <span className="text-nv-muted block mt-1">That Drive Growth</span>
              </h2>

              <div className="mt-10 grid grid-cols-2 gap-6 md:gap-8">
                {stats.map((stat) => (
                  <div key={stat.label}>
                    <p className="text-nv-black text-2xl md:text-3xl font-semibold">{stat.value}</p>
                    <p className="text-nv-muted text-sm mt-1">{stat.label}</p>
                  </div>
                ))}
              </div>
            </div>

            <div
              ref={rightRef}
              className={`lg:w-[52%] flex flex-col gap-6 md:gap-8 transition-all duration-700 delay-200 ${
                rightVisible ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-10'
              }`}
            >
              <div className="rounded-2xl overflow-hidden group">
                <img
                  src="https://static.readdy.ai/image/b83d215482d53eb69b064b5c4f8c0569/f8ac92da9490aed740595f4dab9a4d55.png"
                  alt="Nova Vertex team working together"
                  className="w-full h-64 md:h-80 object-cover object-top group-hover:scale-105 transition-transform duration-700"
                />
              </div>

              <p className="text-nv-black/75 text-base md:text-lg leading-relaxed font-light">
                Nova Vertex LTD is an IT company specializing in custom software
                development, IT consulting, and comprehensive digital solutions. We
                accompany projects at every stage — from idea and analytics through
                development and launch to ongoing support.
              </p>

              <blockquote className="border-l-2 border-nv-black pl-5">
                <p className="text-nv-black text-base leading-relaxed italic">
                  &ldquo;We unite technology and marketing into a single growth
                  strategy. Speed, transparency, and efficiency are our core
                  values — you always see exactly how your project progresses.&rdquo;
                </p>
                <footer className="mt-3 text-sm font-medium text-nv-muted">
                  — Nova Vertex Team
                </footer>
              </blockquote>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}